import { FILTERS } from '~/const';
import { useTenantContext } from '~/context/TenantProvider';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import { isNewAlgoliaIndexesPresent } from '~/utils/env';

function makeAlgoliaFilterFromArray(key: string, values: string[], operator: 'OR' | 'AND' = 'OR') {
  if (values.length === 0) {
    return null;
  }

  const filterString = values.map((value) => `${key}:${value}`).join(` ${operator} `);

  return filterString;
}

const useTenantSearchFilter = () => {
  const { tenant } = useTenantContext();
  const { suiteIDs } = useUserInfoContext();

  // todo: remove this after index migration
  if (!isNewAlgoliaIndexesPresent()) {
    return {};
  }

  const tenantID = typeof tenant?.id === 'string' ? tenant.id : null;

  if (!tenantID) {
    return {};
  }

  const tenantFilter = `${FILTERS.Tenants}:${tenantID}`;

  // when we have suiteIDs - that means that we're logged in and this is use with suites
  if (suiteIDs.length > 0) {
    const suitesFilter = makeAlgoliaFilterFromArray(FILTERS.Suites, suiteIDs, 'OR');

    return {
      tenantFilter: `${tenantFilter} OR (${suitesFilter})`,
    };
  }

  // for an existing users and logged out state - use the same query
  return {
    tenantFilter: `${tenantFilter} OR ${FILTERS.Suites}:${tenantID}`,
  };
};

export default useTenantSearchFilter;
